module.exports = __webpack_public_path__ + "img/011_reiter_thumb.acc5af07.jpg";